import "./TableComponent.css";
import ReactDOM from "react-dom";

import CopyIcon from "../../../assets/copyIcon.svg";
import DeleteIcon from "../../../assets/DeleteIcon";
import DownloadIcon from "../../../assets/Download.svg";
import EditIcon from "../../../assets/EditIcon";
import RevokeIcon from "../../../assets/RevokeIcon";
import { Tooltip } from "react-tooltip";
import ViewIcon from "../../../assets/ViewIcon";
import ViewIconImg from "../../../assets/ViewIcon.svg";
import { useTranslation } from "react-i18next";
import { DMS_ACTIONS } from "../../../utils/constants";

export const getActionColumns = ({
    row,
    rowIndex,
    onEditDetails,
    onViewSlotDetails,
    onViewPICDetails,
    onViewRCMDetails,
    handleView,
    onRevoke,
    tableName,
    onRevokeUser,
    handleAction,
    handlePublishAction,
    handleSurveyExtention,
    onCopyLink,
    onViewDoc,
    handlePublishWithoutWorkflow,
    handlePublishWithWorkflow,
    onDownloadDoc,
    isAssessmentPublished,
    handleSurveyDataDownload,
    handleSurveyTemplateDownload,
    handleViewSurveyDashboard,
    handleEditSurvey,
    handlePreviewSurvey,
    handleReviseDocument,
    handleDeactivateDocument,
    handleDocumentHistory,
    handleApprove,
    handleReject,
    handleRePublishAction,
    // Note:- Following states are used for showing the action options on hover
    isClient,
    setCoords,
    coords,
    setHoveredRow,
    hoveredRow,
    dotRefs,
    userEmail,
    hasChildRows,
    fullData
}) => {

    const { t } = require("react-i18next").useTranslation();
    const actionHandlers = {
        publishWithWorkflow: handlePublishWithWorkflow,
        publishWithoutWorkflow: handlePublishWithoutWorkflow,
        reviseDocument: handleReviseDocument,
        deactivateDocument: handleDeactivateDocument,
        documentHistory: handleDocumentHistory,
    };

    const isSurveyActive = (row)=> {
        if (!row.endDate) return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const endDate = new Date(row.endDate);
        endDate.setHours(0, 0, 0, 0);
        return today <= endDate;
    }

    // Build the actions array using translation keys
    const documentActions = DMS_ACTIONS.map(action => ({
        label: t(action.translationKey),
        key: action.key,
        handler: (row, rowIndex) =>
            actionHandlers[action.key](row, rowIndex, action.key),
    }));
    
    const getRowKey = (row) => `${row.surveyId}-${row.languageMasterId}`;

    switch (tableName) {
        case "level":
        case "template":
            return (
                <span
                    className="deactiveOptionStyle"
                    onClick={() => onEditDetails(row, rowIndex)}
                >
                    <div title={t("update")}>
                        <EditIcon />
                    </div>
                </span>
            );
        case "slot":
            return (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                    }}
                >
                    <span
                        className="viewOptionStyle"
                        onClick={() => onViewSlotDetails(row, rowIndex)}
                    >
                        <div title={t("view")}>
                            {" "}
                            <ViewIcon />{" "}
                        </div>
                    </span>
                    <span
                        className="deactiveOptionStyle"
                        onClick={() => onEditDetails(row, rowIndex)}
                    >
                        <div title={t("edit")}>
                            {" "}
                            <EditIcon />{" "}
                        </div>
                    </span>
                </div>
            );
        case "pic":
            return (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "5px",
                    }}
                >
                    <span
                        className="viewOptionStyle"
                        onClick={() => onViewPICDetails(row, rowIndex)}
                    >
                        <div title={t("view")}>
                            {" "}
                            <ViewIcon />{" "}
                        </div>
                    </span>
                </div>
            );

        case "viewPIC":
            return (
                <div
                    className="editOptionStyle"
                    style={{ marginTop: "5px" }}
                    onClick={() => onRevokeUser(row)}
                >
                    <RevokeIcon />
                </div>
            );

        case "viewRCM":
            return (
                <div
                    className="editOptionStyle"
                    style={{ marginTop: "5px" }}
                    onClick={() => onRevokeUser(row)}
                >
                    <RevokeIcon />
                </div>
            );

        case "rcm":
            return (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "5px",
                    }}
                >
                    <span
                        className="viewOptionStyle"
                        onClick={() => onViewRCMDetails(row, rowIndex)}
                    >
                        <div title={t("view")}>
                            <ViewIcon />
                        </div>
                    </span>
                </div>
            );
        case "GroupDetails":
        case "AdministratorManagement":
        case "ExternalUserManagement":
            return (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        gap: "10px",
                    }}
                >
                    <span
                        data-tooltip-content={t("revoke")}
                        data-tooltip-id={`tooltip-${rowIndex}`}
                        onClick={() => onRevoke(row, rowIndex)}
                        style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <RevokeIcon />
                    </span>
                    {tableName === "AdministratorManagement" && (
                        <span
                            data-tooltip-content={t("edit")}
                            data-tooltip-id={`tooltip-${rowIndex}`}
                            onClick={() => onEditDetails(row, rowIndex)}
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <EditIcon />
                        </span>
                    )}
                </div>
            );
        case "OrganizationManagement":
            return (
                <span
                    onClick={() => onEditDetails(row, rowIndex, "edit")}
                    style={{ cursor: "pointer", marginRight: "10px" }}
                >
                    <EditIcon />
                </span>
            );
        case "GroupManagement":
        case "DomainManagement":
            return (
                <div>
                    <span
                        onClick={() => onEditDetails(row, rowIndex)}
                        style={{ cursor: "pointer", marginRight: "10px" }}
                    >
                        <EditIcon />
                    </span>
                    <span
                        onClick={() => handleView(row)}
                        style={{ cursor: "pointer" }}
                    >
                        <img
                            src={ViewIconImg}
                            alt={t("view")}
                            style={{ width: "20px", height: "20px" }}
                        />
                    </span>
                </div>
            );

        case "Survey":
    const rowKey = getRowKey(row);
    const isChild = row.languageMasterId !== 1; // or your own logic for parent/child

    return (
        <div className="actionContainer">
            <div className="actionDots"
                ref={el => dotRefs.current[rowKey] = el}
                onMouseEnter={() => {
                    const el = dotRefs.current[rowKey];
                    if (el) {
                        const rect = el.getBoundingClientRect();
                        setCoords({
                            top: rect.top,
                            left: rect.left - 110
                        });
                    }
                    setHoveredRow(rowKey);
                }}
                onMouseLeave={() => setHoveredRow(null)}
            >
                <span>.</span>
                <span>.</span>
                <span>.</span>
            </div>

            {isClient && hoveredRow === rowKey &&
                ReactDOM.createPortal(
                    <div className="actionOptions"
                        style={{
                            top: coords.top,
                            left: coords.left,
                        }}
                        onMouseEnter={() => setHoveredRow(rowKey)}
                        onMouseLeave={() => setHoveredRow(null)}
                    >
                        {isChild ? (
                            <>
                                {row.isPublished === true ? (
                                    <>
                                        {/* <span onClick={() => handleAction("Deactivate", row, rowIndex)}>
                                            {t("deactivate")}
                                        </span>  */}
                                        <span onClick={() => handleAction("Delete", row, rowIndex)}>
                                            {t("delete")}
                                        </span>
                                    </> 
                                ) : (
                                    <>
                                        {row.status === "Inactive" ? (
                                            <>
                                                {/* <span onClick={() => handleAction("Activate", row, rowIndex)}>
                                                    {t("activate")}
                                                </span> */}
                                                <span onClick={() => handleAction("Delete", row, rowIndex)}>
                                                    {t("delete")}
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                <span onClick={() => handleEditSurvey(row, hasChildRows ? hasChildRows(row) : false)}>
                                                    {t("editSurvey")}
                                                </span>
                                                <span onClick={() => handlePreviewSurvey(row)}>
                                                    {t("previewSurvey")}
                                                </span>
                                                <span onClick={() => handleAction("Delete", row, rowIndex)}>
                                                    {t("delete")}
                                                </span> 
                                            </>
                                        )}
                                    </> 
                                )}   
                            </> 
                        ) : (
                            <>
                                {row.status === "Active" && row.isPublished === false && (
                                    <>
                                        <span onClick={() => handleEditSurvey(row, hasChildRows ? hasChildRows(row) : false)}>
                                            {t("editSurvey")}
                                        </span>
                                        <span onClick={() => handlePreviewSurvey(row)}>
                                            {t("previewSurvey")}
                                        </span>
                                        <span onClick={() => handlePublishAction("Publish", row, rowIndex)}>
                                            {t("publish")}
                                        </span>
                                        <span onClick={() => handleSurveyTemplateDownload(row)}>
                                            {t("downloadSurveyTemplate")}
                                        </span>
                                    </>
                                )}

                                {row.isPublished === true && (
                                    <>
                                        <span onClick={() => handleViewSurveyDashboard(row)}>
                                            {t("viewSurveyDashboard")}
                                        </span>
                                        <span onClick={() => handleSurveyExtention("survey_extention", row, rowIndex)}>
                                            {t("surveyExtension")}
                                        </span>
                                        {/* <span onClick={() => handleSurveyDataDownload(row)}>
                                            {t("downloadSurveyData")}
                                        </span> */}
                                    </>
                                )}
                                {row.status === "Inactive" && (
                                    <span onClick={() => handleAction("Activate", row, rowIndex)}>
                                        {t("activate")}
                                    </span>
                                )}

                                {row.isPublished === false && row.status !== 'Inactive' && (
                                    <span onClick={() => handleAction("Deactivate", row, rowIndex)}>
                                        {t("deactivate")}
                                    </span>
                                )}

                                {row.isPublished === false && !(hasChildRows && hasChildRows(row)) && (
                                    <span onClick={() => handleAction("Delete", row, rowIndex)}>
                                        {t("delete")}
                                    </span>
                                )}

                                {row.isPublished === true && (
                                    <>
                                        {row.endDate &&
                                             new Date().setHours(0, 0, 0, 0) > new Date(row.endDate).setHours(0, 0, 0, 0) && 
                                            !(hasChildRows && hasChildRows(row)) && (
                                                <span onClick={() => handleAction("Delete", row, rowIndex)}>
                                                    {t("delete")}
                                                </span>
                                            )}
                                    </>
                                )}

                                {(row.isPublished === true && row.isCoded !== true) && (
                                    <>
                                        {isSurveyActive(row) && (
                                            <span onClick={() => handleAction("Reminder", row, rowIndex)}>
                                                {t("reminder")}
                                            </span>
                                        )}
                                    </>
                                )}
                                {row.isCoded === true && isSurveyActive(row) && (
                                    <span onClick={() => onCopyLink(row, rowIndex)}>
                                        {t("copyLink")}
                                    </span>
                                )}

                                {row.isCoded === false && row.isPublished === true && isSurveyActive(row) && (
                                    <span onClick={() => handleRePublishAction("Republish", row, rowIndex)}>
                                        {t("republish")}
                                    </span>
                                )}
                            </>
                        )}
                    </div>,
                    document.body
                )}
        </div>
    );

        case "userSurvey":
            return (
                <div className="td-action">
                    <span
                        data-tooltip-content={t("viewSurvey")}
                        data-tooltip-id={`tooltip-${rowIndex}`}
                        className="action-icons"
                    >
                        <img
                            src={ViewIconImg}
                            onClick={() => onViewDoc(row, rowIndex)}
                        />
                        <Tooltip id={`tooltip-${rowIndex}`} place="left" />
                    </span>
                </div>
            );

        case "":
        case "PendingApprovalDocuments":
        case "Document":
            return (
                <div className="actionContainer">
                    <div className="actionDots"
                        ref={el => dotRefs.current[rowIndex] = el}
                        onMouseEnter={() => {
                            const el = dotRefs.current[rowIndex];
                            if (el) {
                                const rect = el.getBoundingClientRect();
                                setCoords({
                                    top: rect.top,
                                    left: rect.left - 110
                                });
                            }
                            setHoveredRow(rowIndex);
                        }}
                        onMouseLeave={() => setHoveredRow(null)}
                    >
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                    </div>

                    { tableName === "Document" && isClient && hoveredRow === rowIndex &&
                        ReactDOM.createPortal(
                            <div className="actionOptions"
                                style={{
                                    top: coords.top,
                                    left: coords.left,
                                }}
                                onMouseEnter={() => setHoveredRow(rowIndex)}
                                onMouseLeave={() => setHoveredRow(null)}
                            >
                                {documentActions.map((action, index) => {
                                    const isReviseAction = action.key === "reviseDocument";
                                    if (!row.isActive) {
                                        if (
                                            isReviseAction ||
                                            action.key === "documentHistory"
                                        ) {
                                            return (
                                                <span
                                                    key={index}
                                                    onClick={() =>
                                                        action.handler(
                                                            row,
                                                            rowIndex,
                                                            action.key
                                                        )
                                                    }
                                                >
                                                    {action.label}
                                                </span>
                                            );
                                        }
                                        return null;
                                    }
                                    if (
                                        row.isPublished &&
                                        (action.key === "publishWithWorkflow" ||
                                            action.key === "publishWithoutWorkflow")
                                    ) {
                                        return null;
                                    }
                                    if (
                                        row.documentWorkFlowStatus ===
                                        "PendingForApproval" &&
                                        (action.key === "publishWithWorkflow" ||
                                            action.key === "publishWithoutWorkflow" ||
                                            action.key === "reviseDocument" ||
                                            action.key === "deactivateDocument")
                                    ) {
                                        return null;
                                    }
                                    return (
                                        <span
                                            key={index}
                                            onClick={() =>
                                                action.handler(
                                                    row,
                                                    rowIndex,
                                                    action.key
                                                )
                                            }
                                        >
                                            {action.label}
                                        </span>
                                    );
                                })}
                            </div>,
                            document.body // <-- This is required!
                    )}

                    {row.status === "PendingForApproval" && (
                        isClient && hoveredRow === rowIndex &&
                        ReactDOM.createPortal(
                            <div className="actionOptions"
                                style={{
                                    top: coords.top,
                                    left: coords.left,
                                }}
                                onMouseEnter={() => setHoveredRow(rowIndex)}
                                onMouseLeave={() => setHoveredRow(null)}
                            >
                                <span onClick={() => onViewDoc(row, rowIndex)}>
                                    {t("viewDocument")}
                                </span>
                               { (row?.workFlowApproverEmail?.toLowerCase().trim() === userEmail?.toLowerCase().trim()) && <> <span
                                    onClick={() =>
                                        handleApprove(row, rowIndex, "approve")
                                    }
                                >
                                    {t("approve")}
                                </span>
                                <span
                                    onClick={() =>
                                        handleReject(row, rowIndex, "reject")
                                    }
                                >
                                    {t("reject")}
                                </span></>
                                }
                            </div>,
                            document.body // <-- This is required!
                        )
                        
                    )}
                </div>
            );

        case "versionInfo":
            return (
                <div className="td-action">
                    {tableName === "UserDocument" && (
                        <>
                            <span
                                data-tooltip-content={t("downloadDocument")}
                                data-tooltip-id={`tooltip-${rowIndex}`}
                                className="action-icons"
                                onClick={() => onDownloadDoc(row, rowIndex)}
                            >
                                <img src={DownloadIcon} />
                                <Tooltip
                                    id={`tooltip-${rowIndex}`}
                                    place="left"
                                />
                            </span>
                            <span
                                data-tooltip-content={t("copyDocumentLink")}
                                data-tooltip-id={`tooltip-${rowIndex}`}
                            >
                                <img
                                    src={CopyIcon}
                                    style={{
                                        width: "25px",
                                        marginLeft: "-5px",
                                        padding: "5px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => onCopyLink(row, rowIndex)}
                                />
                            </span>
                        </>
                    )}
                    <span
                        data-tooltip-content={
                            tableName === "versionInfo"
                                ? row.documentUrl.split("/").pop()
                                : tableName === "userSurvey"
                                    ? t("viewSurvey")
                                    : t("viewDocument")
                        }
                        data-tooltip-id={`tooltip-${rowIndex}`}
                        className="action-icons"
                    >
                        <img
                            src={ViewIconImg}
                            onClick={() => onViewDoc(row, rowIndex)}
                        />
                        <Tooltip id={`tooltip-${rowIndex}`} place="left" />
                    </span>
                </div>
            );

        case "UserDocument":
            return (
                <div className="td-action">
                    <span
                        data-tooltip-content={t("downloadDocument")}
                        data-tooltip-id={`tooltip-${rowIndex}`}
                        className="action-icons"
                        onClick={() => onDownloadDoc(row, rowIndex)}
                    >
                        <img src={DownloadIcon} />
                        <Tooltip id={`tooltip-${rowIndex}`} place="left" />
                    </span>
                    {row?.documentAccessibilityLevelName !== "Confidential" && (
                        <span
                            data-tooltip-content={t("copyDocumentLink")}
                            data-tooltip-id={`tooltip-${rowIndex}`}
                        >
                            <img
                                src={CopyIcon}
                                style={{
                                    width: "25px",
                                    marginLeft: "-5px",
                                    padding: "5px",
                                    cursor: "pointer",
                                }}
                                onClick={() => onCopyLink(row, rowIndex)}
                            />
                        </span>
                    )}
                    {/* <span
                        data-tooltip-content={
                            tableName === "versionInfo"
                                ? row.documentUrl.split("/").pop()
                                : tableName === "userSurvey"
                                    ? t("viewSurvey")
                                    : t("viewDocument")
                        }
                        data-tooltip-id={`tooltip-${rowIndex}`}
                        className="action-icons"
                    >
                        <img
                            src={ViewIconImg}
                            onClick={() => onViewDoc(row, rowIndex)}
                        />
                        <Tooltip id={`tooltip-${rowIndex}`} place="left" />
                    </span> */}
                </div>
            );

        case "AdminAssessmentTableView":
            return !isAssessmentPublished ? (
                <div>
                    <span
                        onClick={() => onEditDetails(row, rowIndex, "edit")}
                        style={{
                            cursor: "pointer",
                            marginRight: "10px",
                        }}
                    >
                        <EditIcon />
                    </span>
                    <span
                        onClick={() => onEditDetails(row, rowIndex, "delete")}
                        style={{
                            cursor: "pointer",
                            marginRight: "10px",
                        }}
                    >
                        <DeleteIcon />
                    </span>
                </div>
            ) : (
                <span
                    style={{
                        fontWeight: "normal",
                        fontSize: "13px",
                    }}
                >
                    N/A
                </span>
            );

        case "AdminAssessmentTable":
            return (
                <span className="action-icons">
                    <img
                        src={ViewIconImg}
                        onClick={() => onEditDetails(row, rowIndex, "view")}
                    />
                    <Tooltip
                        id={`tooltip-${rowIndex}`}
                        place="bottom"
                        className="custom-tooltip1"
                    />
                </span>
            );
        // Add more cases as needed
        default:
            return null;
    }
};
